export default (() => {
  if (!customElements.get('review-product')) {
    customElements.define('review-product', class ReviewProduct extends HTMLElement {
      constructor() {
        super();
        this.sku = this.getAttribute('data-sku') || '';
        this.ratingNumberEl = this.querySelector('[data-rating-number]');
        this.ratingStarsEl = this.querySelector('[data-rating-stars]');
        this.ratingCountEl = this.querySelector('[data-rating-count]');
        this.ratingTextEl = this.querySelector('[data-rating-text]');
      }
      async connectedCallback() {
        if (!window.Shopify?.app_config?.reviews_io?.store || !this.sku.trim()) return;
        try {
          const response = await fetch(`https://api.reviews.io/product/rating-batch?store=${window.Shopify.app_config.reviews_io.store}&sku=${this.sku}`, {
            headers: {
              accept: 'application/json'
            }
          });
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
          const data = await response.json();
          let totalRatings = 0;
          let ratingCount = 0;
          if (Array.isArray(data)) {
            ({
              totalRatings,
              ratingCount
            } = data.reduce((acc, sku) => ({
              totalRatings: acc.totalRatings + parseFloat(sku.average_rating || 0) * parseInt(sku.num_ratings || 0),
              ratingCount: acc.ratingCount + parseInt(sku.num_ratings || 0)
            }), {
              totalRatings: 0,
              ratingCount: 0
            }));
          }
          const formatRating = rating => {
            const ratingStr = String(rating);
            if (ratingStr.includes('.')) {
              const [whole, decimal] = ratingStr.split('.');
              return decimal.length > 1 ? `${whole}.${decimal.slice(0, 1)}` : ratingStr;
            }
            return ratingStr;
          };
          const averageRating = parseFloat((totalRatings / ratingCount).toFixed(2)) || 0;
          if (averageRating === 0) {
            this.style.display = 'none';
            return;
          }
          const updated = [averageRating && this.ratingNumberEl && (this.ratingNumberEl.textContent = formatRating(averageRating)), averageRating && this.ratingStarsEl && (this.ratingStarsEl.style.width = `${averageRating * 20}%`), ratingCount && this.ratingCountEl && (this.ratingCountEl.textContent = ratingCount.toLocaleString())].some(Boolean);
          if (updated) {
            if (this.ratingTextEl) this.ratingTextEl.textContent = ratingCount > 1 ? window.strings?.review?.other : window.strings?.review?.one;
            setTimeout(() => this.classList.remove('opacity-0', 'pointer-events-none'), 100);
          }
        } catch (error) {
          console.error('Error fetching product review stats:', error);
        }
      }
    });
  }
})();